// Angular
import {
    Component,
    Input,
    OnInit,
    AfterViewInit
} from "@angular/core";

@Component({
    selector: 'progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})

export class ProgressBarComponent implements AfterViewInit {
    @Input() remainingTime: number;
    @Input() totalTime: number;
    progressBarIsValid: boolean;
    remainingTimePersentage : any = 0;
    progressBarWidth: string = "0";
    IntervalCounter: any;

    constructor() {}

    ngAfterViewInit() {
        // console.log("ProgressBarComponent");
        // console.log("this.remainingTime", this.remainingTime);
        // console.log("this.totalTime", this.totalTime);
        // this.remainingTimePersentage = Math.floor((this.remainingTime / this.totalTime) * 100);
       // console.log("remainingTimePersentage", this.remainingTimePersentage);
        // this.progressBarwidth = `${this.remainingTimePersentage}%`;
     //   console.log("this.progressBarwidth", this.progressBarwidth);
        
        this.IntervalCounter =  setInterval(() => this.msToTime(this.remainingTime), 1000);
    };

    msToTime(s) {
        if (this.totalTime > this.remainingTime) {
            this.progressBarIsValid = true;
            this.remainingTimePersentage = Math.floor((this.remainingTime / this.totalTime) * 100);
            // console.log("this.remainingTimePersentage", this.remainingTimePersentage);

            this.progressBarWidth = `${this.remainingTimePersentage}%`;
            // console.log("this.progressBarWidth", this.progressBarWidth);

            this.remainingTime = this.remainingTime - 1000;
            // console.log("this.remainingTime", this.remainingTime);
        } else if (this.totalTime < this.remainingTime) {
            this.progressBarWidth = "0%";
            this.progressBarIsValid = false;
        }
        
    };

    ngOnDestroy() {
        console.log("ngOnDestroy");
        if (this.IntervalCounter) {
          clearInterval(this.IntervalCounter);
        }
      }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/progressBar/progress-bar.component.ts